"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
const Log_1 = __importStar(require("@common/Log"));
const Factory_1 = require("./Factory");
const ClassMode_1 = require("./util/ClassMode");
const Network_1 = require("./util/Network");
const UI_1 = require("./util/UI");
const ViewAs_1 = require("./util/ViewAs");
class App {
    constructor() {
        this.backendURL = null;
        this.frontendURL = null;
        this.view = null;
        this.validated = false;
        this.config = null;
        this.loginCheckInFlight = false;
        Log_1.default.trace("App::<init> - start");
        let location = window.location.href;
        location = location.substr(0, location.indexOf("/", 10));
        Log_1.default.trace("App::<init> - location: " + location);
        this.frontendURL = location;
        this.backendURL = location;
        if (location.indexOf("//localhost:3000") >= 0) {
            Log_1.default.info("App::<init> - rewriting backend URL for testing");
        }
        Log_1.default.trace("App::<init> - frontend: " + this.frontendURL);
        Log_1.default.trace("App::<init> - backend: " + this.backendURL);
        if (this.frontendURL.indexOf("localhost") < 0 && this.backendURL.indexOf("localhost") < 0) {
            Log_1.default.Level = Log_1.LogLevel.INFO;
        }
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.trace("App::init() - start");
            const that = this;
            this.config = yield this.retrieveConfig();
            const validated = yield that.validateCredentials();
            this.validated = validated;
            if (validated === true) {
                Log_1.default.trace("App::init() - validated: true; simulating mainPageClick");
                that.handleMainPageClick();
            }
            else {
                Log_1.default.trace("App::init() - validated: false");
            }
            return new Promise(function (fulfill, reject) {
                document.addEventListener("init", function (event) {
                    const page = event.target;
                    that
                        .performInit(page.id)
                        .then(function () {
                    })
                        .catch(function (err) {
                    });
                });
                document.addEventListener("show", function (event) {
                    const page = event.target;
                    const pageName = page.id;
                    let options = page.pushedOptions;
                    if (typeof options === "undefined") {
                        options = {};
                    }
                    Log_1.default.trace("App::init()::show - page: " + pageName + "; validated: " + validated + "; event: " + JSON.stringify(event));
                    that.toggleLoginButton();
                    ViewAs_1.ViewAs.renderBanner(() => {
                        window.location.reload();
                    });
                    if (that.view !== null) {
                        Log_1.default.trace("App::init()::show - calling view.renderPage for: " + pageName);
                        that.view.renderPage(pageName, options);
                    }
                    else {
                        Log_1.default.trace("App::init()::show - view is null; cannot call view.renderPage for: " + pageName);
                    }
                });
                Log_1.default.trace("App::init()::init - loading initial index");
                UI_1.UI.pushPage(Factory_1.Factory.getInstance().getHTMLPrefix() + "/landing.html")
                    .then(function () {
                })
                    .catch(function (err) {
                    Log_1.default.error("UI::pushPage(..) - ERROR: " + err);
                });
                fulfill({});
            });
        });
    }
    performInit(pageName) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("App::performInit() - start");
            const that = this;
            this.toggleLoginButton();
            let name = null;
            name = Factory_1.Factory.getInstance().getName();
            Log_1.default.trace("App::performInit() - name : " + name + "; page: " + pageName + "; opts: " + JSON.stringify(event));
            if (pageName === "index") {
                Log_1.default.trace("App::performInit() - index detected; pushing real target");
                UI_1.UI.pushPage(Factory_1.Factory.getInstance().getHTMLPrefix() + "/landing.html")
                    .then(function () {
                })
                    .catch(function (err) {
                    Log_1.default.error("App::performInit(..) - ERROR: " + err.message);
                });
                return;
            }
            if (this.view === null) {
                let v = null;
                Log_1.default.info("App::performInit() - init; null view; pageName: " + pageName);
                if (pageName === "AdminRoot") {
                    Log_1.default.info("App::init() - AdminRoot init; attaching view");
                    v = yield Factory_1.Factory.getInstance().getAdminView(this.backendURL);
                    Log_1.default.trace("App::performInit() - AdminRoot init; view attached");
                }
                else if (pageName === "StudentRoot") {
                    Log_1.default.info("App::performInit() - StudentRoot init; attaching view");
                    v = yield Factory_1.Factory.getInstance().getView(this.backendURL);
                    Log_1.default.trace("App::performInit() - StudentRoot init; view attached");
                }
                else {
                    Log_1.default.warn("App::performInit() - UNKNOWN page name: " + pageName);
                }
                window.myApp.view = v;
                this.view = v;
            }
            if (pageName === "loginPage") {
                Log_1.default.trace("App::performInit() - loginPage init; attaching login button");
                document.querySelector("#loginButton").onclick = function () {
                    that.loginPressed(name).catch(function (err) {
                        Log_1.default.error("App::performInit() - login ERROR: " + err.message);
                    });
                };
                that.warnIfAuthHostUnreachable().catch(function (err) {
                    Log_1.default.warn("App::performInit() - auth host check ERROR: " + err.message);
                });
            }
        });
    }
    getAdminController(org) {
        Log_1.default.trace("App::getAdminController( " + org + " )");
    }
    pushPage(page, opts) {
        UI_1.UI.pushPage(page, opts)
            .then(function () {
        })
            .catch(function (err) {
            Log_1.default.error("UI::pushPage(..) - ERROR: " + err.message);
        });
    }
    handleMainPageClick(params) {
        if (typeof params === "undefined") {
            params = {};
        }
        Log_1.default.trace("App::handleMainPageClick( " + JSON.stringify(params) + " ) - start");
        if (this.validated === true) {
            Log_1.default.info("App::handleMainPageClick(..) - authorized");
            params.isAdmin = localStorage.isAdmin === "true";
            params.isStaff = localStorage.isStaff === "true";
            if (ViewAs_1.ViewAs.isActive() === true) {
                Log_1.default.info("App::handleMainPageClick(..) - viewing as: " + ViewAs_1.ViewAs.target());
                params.isAdmin = false;
                params.isStaff = false;
            }
            if (params.isAdmin || params.isStaff) {
                Log_1.default.trace("App::handleMainPageClick(..) - admin");
                Log_1.default.Level = Log_1.LogLevel.TRACE;
                UI_1.UI.pushPage(Factory_1.Factory.getInstance().getHTMLPrefix() + "/admin.html", params)
                    .then(function () {
                })
                    .catch(function (err) {
                    Log_1.default.error("UI::pushPage(..) - ERROR: " + err.message);
                });
            }
            else {
                Log_1.default.trace("App::handleMainPageClick(..) - student");
                UI_1.UI.pushPage(Factory_1.Factory.getInstance().getHTMLPrefix() + "/student.html", params)
                    .then(function () {
                })
                    .catch(function (err) {
                    Log_1.default.error("UI::pushPage(..) - ERROR: " + err.message);
                });
            }
        }
        else {
            Log_1.default.info("App::handleMainPageClick(..) - not authorized");
            UI_1.UI.pushPage(Factory_1.Factory.getInstance().getHTMLPrefix() + "/login.html", params)
                .then(function () {
            })
                .catch(function (err) {
                Log_1.default.error("UI::pushPage(..) - ERROR: " + err.message);
            });
        }
    }
    isLoggedIn() {
        return this.validated === true;
    }
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.trace("App::logout() - start");
            yield this.clearCredentials();
            UI_1.UI.pushPage("index.html")
                .then(function () {
            })
                .catch(function (err) {
                Log_1.default.error("UI::pushPage(..) - ERROR: " + err.message);
            });
        });
    }
    validateCredentials() {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("App::validateCredentials() - start");
            let token = null;
            let userId = null;
            const tokenString = this.readCookie("token");
            if (tokenString !== null) {
                const tokenParts = tokenString.split("__");
                if (tokenParts.length === 1) {
                    token = tokenParts[0];
                }
                else if (tokenParts.length === 2) {
                    token = tokenParts[0];
                    userId = tokenParts[1];
                }
            }
            if (token === null) {
                Log_1.default.info("App::validateCredentials() - token not set on cookie");
                token = localStorage.getItem("token");
            }
            if (userId === null) {
                Log_1.default.info("App::validateCredentials() - userId not set on cookie");
                token = localStorage.getItem("user");
            }
            if (token === null || userId === null) {
                Log_1.default.info("App::validateCredentials() - user or token not set on cookie or localstorage; clearing for safety");
                this.clearCredentials()
                    .then(function () {
                })
                    .catch(function (err) {
                    Log_1.default.trace("App::validateCredentials(..) - clear credentials error: " + err.message);
                });
            }
            else {
                Log_1.default.info("App::validateCredentials() - token available");
                const githubId = yield this.getGithubCredentials(token);
                if (githubId !== null) {
                    Log_1.default.info("App::validateCredentials() - valid GitHub id: " + githubId);
                    const credentials = yield this.getServerCredentials(userId, token);
                    if (credentials === null || typeof credentials.failure !== "undefined") {
                        Log_1.default.info("App::validateCredentials() - server validation failed");
                        this.clearCredentials()
                            .then(function () {
                        })
                            .catch(function (err) {
                            Log_1.default.trace("App::validateCredentials(..) - clear credentials error: " + err.message);
                        });
                    }
                    else {
                        Log_1.default.info("App::validateCredentials() - validated with server; isAdmin: " +
                            credentials.success.isAdmin +
                            "; isStaff: " +
                            credentials.success.isStaff);
                        localStorage.setItem("user", credentials.success.personId);
                        localStorage.setItem("token", credentials.success.token);
                        localStorage.setItem("isAdmin", credentials.success.isAdmin + "");
                        localStorage.setItem("isStaff", credentials.success.isStaff + "");
                        return true;
                    }
                }
                else {
                    Log_1.default.info("App::validateCredentials() - invalid username; clearing for safety");
                    this.clearCredentials()
                        .then(function () {
                    })
                        .catch(function (err) {
                        Log_1.default.trace("App::validateCredentials(..) - clear credentials error: " + err.message);
                    });
                }
            }
            Log_1.default.info("App::validateCredentials() - returning false");
            return false;
        });
    }
    clearCredentials() {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("App::clearCredentials() - start");
            const that = this;
            const user = localStorage.getItem("user");
            const token = localStorage.getItem("token");
            if (user !== null) {
                const url = this.backendURL + "/portal/logout";
                Log_1.default.trace("App::clearCredentials( " + user + "...) - start; url: " + url);
                const name = Factory_1.Factory.getInstance().getName();
                const options = {
                    headers: {
                        "Content-Type": "application/json",
                        "User-Agent": "Portal",
                        user: user,
                        token: token,
                        name: name,
                    },
                };
                const finishLogout = function () {
                    that.validated = false;
                    localStorage.clear();
                    ClassMode_1.ClassMode.clear();
                    document.cookie = "token=empty;expires=" + new Date(0).toUTCString();
                    location.href = location.href;
                    return;
                };
                return fetch(url, options)
                    .then(function (resp) {
                    Log_1.default.info("App::clearCredentials() - status: " + resp.status);
                    return finishLogout();
                })
                    .catch(function (err) {
                    Log_1.default.error("App::clearCredentials(..) - ERROR: " + err);
                    return finishLogout();
                });
            }
        });
    }
    getGithubCredentials(token) {
        Log_1.default.trace("App::getGithubCredentials(..) - start");
        return fetch(this.config.githubAPI + "/user", {
            headers: {
                "Content-Type": "application/json",
                Authorization: "token " + token,
            },
        })
            .then(function (resp) {
            Log_1.default.trace("App::getGithubCredentials(..) - resp status: " + resp.status);
            return resp.json();
        })
            .then(function (data) {
            Log_1.default.trace("App::getGithubCredentials(..) - data then: " + data.login);
            if (typeof data.login !== "undefined") {
                return data.login;
            }
            return null;
        })
            .catch(function (err) {
            Log_1.default.error("App::getGithubCredentials(..) - ERROR: " + err);
            return null;
        });
    }
    getServerCredentials(username, token) {
        const url = this.backendURL + "/portal/getCredentials";
        Log_1.default.trace("App::getServerCredentials( " + username + "...) - start; url: " + url);
        const that = this;
        const name = Factory_1.Factory.getInstance().getName();
        const options = {
            headers: {
                "Content-Type": "application/json",
                "User-Agent": "Portal",
                user: username,
                token: token,
                name: name,
            },
        };
        return fetch(url, options)
            .then(function (resp) {
            Log_1.default.trace("App::getServerCredentials(..) - resp status: " + resp.status);
            if (resp.status === 204) {
                Log_1.default.trace("App::getServerCredentials(..) - fetching");
                return fetch(url, options);
            }
            else {
                Log_1.default.trace("App::getServerCredentials(..) - passing through");
                Log_1.default.trace("App::getServerCredentials(..) - code returned: " + resp.status);
                if (resp.status === 400) {
                    that
                        .clearCredentials()
                        .then(function () {
                    })
                        .catch(function (err) {
                        Log_1.default.trace("App::getServerCredentials(..) - clear credentials error: " + err.message);
                    });
                }
                return resp;
            }
        })
            .then(function (resp) {
            Log_1.default.trace("App::getServerCredentials(..) - data status: " + resp.status);
            return resp.json();
        })
            .then(function (data) {
            Log_1.default.trace("App::getServerCredentials(..) - data json: " + JSON.stringify(data));
            return data;
        })
            .catch(function (err) {
            Log_1.default.error("App::getServerCredentials(..) - ERROR: " + err);
            return null;
        });
    }
    loginPressed(name) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = this.backendURL + "/portal/auth?name=" + name;
            Log_1.default.info("App::loginPressed() - login pressed for: " + name + "; url: " + url);
            const host = this.config === null ? null : this.config.githubHost;
            const button = document.querySelector("#loginButton");
            button.disabled = true;
            this.loginCheckInFlight = true;
            App.setLoginMessage("Checking the connection to " + App.hostLabel(host) + "...", false);
            let reachable;
            try {
                reachable = yield App.isAuthHostReachable(host, 2000);
            }
            finally {
                button.disabled = false;
                this.loginCheckInFlight = false;
            }
            if (reachable === false) {
                Log_1.default.warn("App::loginPressed() - auth host unreachable: " + host);
                App.setLoginMessage(App.vpnMessage(host), true);
                return;
            }
            App.setLoginMessage(null, false);
            window.location.replace(url);
        });
    }
    warnIfAuthHostUnreachable() {
        return __awaiter(this, void 0, void 0, function* () {
            const host = this.config === null ? null : this.config.githubHost;
            if (typeof host !== "string" || host === "") {
                return;
            }
            const reachable = yield App.isAuthHostReachable(host, 2000);
            if (reachable === true || this.loginCheckInFlight === true) {
                return;
            }
            if (document.querySelector("#loginButton") !== null) {
                Log_1.default.warn("App::warnIfAuthHostUnreachable() - auth host unreachable: " + host);
                App.setLoginMessage(App.vpnMessage(host), true);
            }
        });
    }
    static vpnMessage(host) {
        return ("<b>Cannot reach " +
            App.hostLabel(host) +
            ".</b><br/><br/>" +
            "You must be connected to ubcsecure on campus or using the UBC VPN to sign in. " +
            "<br/><br/>Please connect to the VPN and try again.");
    }
    static isAuthHostReachable(host_1) {
        return __awaiter(this, arguments, void 0, function* (host, timeoutMs = 5000) {
            if (typeof host !== "string" || host === "") {
                Log_1.default.warn("App::isAuthHostReachable() - no host configured; skipping check");
                return true;
            }
            const controller = new AbortController();
            const timer = setTimeout(function () {
                controller.abort();
            }, timeoutMs);
            try {
                yield fetch(host + "/favicon.ico", {
                    mode: "no-cors",
                    cache: "no-store",
                    credentials: "omit",
                    signal: controller.signal,
                });
                return true;
            }
            catch (err) {
                Log_1.default.warn("App::isAuthHostReachable( " + host + " ) - not reachable: " + err.name);
                return false;
            }
            finally {
                clearTimeout(timer);
            }
        });
    }
    static setLoginMessage(html, isError) {
        let el = document.querySelector("#loginMessage");
        if (el === null) {
            const button = document.querySelector("#loginButton");
            if (button === null || button.parentElement === null) {
                return;
            }
            el = document.createElement("div");
            el.id = "loginMessage";
            el.style.paddingTop = "1em";
            el.style.textAlign = "center";
            button.parentElement.appendChild(el);
        }
        el.style.color = isError === true ? "#b00020" : "";
        el.innerHTML = html === null ? "" : html;
    }
    static hostLabel(host) {
        if (typeof host !== "string" || host === "") {
            return "the UBC GitHub server";
        }
        return host.replace(/^https?:\/\//, "").replace(/\/$/, "");
    }
    retrieveConfig() {
        return __awaiter(this, void 0, void 0, function* () {
            const url = this.backendURL + "/portal/config";
            Log_1.default.trace("App::retrieveConfig() - start; url: " + url);
            const options = {
                headers: {
                    "Content-Type": "application/json",
                    "User-Agent": "Portal",
                },
            };
            const response = yield fetch(url, options);
            if (response.status === 200) {
                Log_1.default.trace("App::retrieveConfig() - status: " + response.status);
                const json = yield response.json();
                if (typeof json.success !== "undefined") {
                    Log_1.default.trace("App::retrieveConfig() - success; payload: " + JSON.stringify(json) + "; setting org: " + json.success.org);
                    Factory_1.Factory.getInstance(json.success.name);
                    return json.success;
                }
                else {
                    Log_1.default.error("App::retrieveConfig() - failed: " + JSON.stringify(json) + ")");
                    return {
                        org: "ERROR",
                        name: "ERROR",
                        githubAPI: null,
                        githubHost: null,
                        studentsFormTeamDelivIds: null,
                        prairieLearnEnabled: false,
                    };
                }
            }
            else {
                Log_1.default.error("App::retrieveConfig() - ERROR");
                return { org: "ERROR", name: "ERROR", githubAPI: null, githubHost: null, studentsFormTeamDelivIds: null, prairieLearnEnabled: false };
            }
        });
    }
    readCookie(name) {
        Log_1.default.trace("App::readCookie( " + name + " ) - start; cookie string: " + document.cookie);
        const s = decodeURI(document.cookie).split(";");
        for (const cookie of s) {
            const row = cookie.split("=", 2);
            if (row.length === 2) {
                const key = row[0].trim();
                if (key === name) {
                    Log_1.default.trace("App::readCookie( " + name + " ) - cookie found");
                    return row[1].trim();
                }
            }
        }
        Log_1.default.trace("App::readCookie( " + name + " ) - no token found");
        return null;
    }
    toggleLoginButton() {
        try {
            if (this.isLoggedIn() === true) {
                const el = document.getElementById("indexLogin");
                if (el !== null) {
                    el.style.display = "block";
                }
                else {
                }
            }
            else {
                const el = document.getElementById("indexLogin");
                if (el !== null) {
                    el.style.display = "none";
                }
                else {
                }
            }
        }
        catch (err) {
            Log_1.default.error("App:toggleLoginButton() - ERROR: " + err);
        }
    }
}
exports.App = App;
Log_1.default.info("App.ts - preparing Classy client");
if (typeof classportal === "undefined") {
    Log_1.default.trace("App.ts - preparing App; defining globals");
    window.classportal = {};
    window.classportal.App = App;
    window.classportal.UI = UI_1.UI;
    window.classportal.Network = Network_1.Network;
}
window.myApp = new classportal.App();
window.myApp
    .init()
    .then(function (ret) {
    Log_1.default.info("App.ts - Classy client prepared: " + JSON.stringify(ret));
})
    .catch(function (err) {
    Log_1.default.error("App.ts - init ERROR: " + err);
});
